import { BalloonOutlineIcon } from '@carboncopyco/icons';
import { ToggleButton, TooltipBubble } from '@carboncopyco/ui';
import { forwardRef, useImperativeHandle, useMemo, useState } from 'react';
import { useEditor } from '../../context/EditorSdkProvider';

interface Props {
  onButtonClick: (val: boolean) => void;
}

export type GuidanceTooltipsButtonRef = {
  reset: () => void;
} | null;

export const GuidanceTooltipsButton = forwardRef<
  GuidanceTooltipsButtonRef,
  Props
>(({ onButtonClick }, ref) => {
  const [areTooltipsVisible, setAreTooltipsVisible] = useState(false);

  useImperativeHandle(
    ref,
    () => ({
      reset: () => reset(),
    }),
    []
  );

  const {
    showAllGuidanceTooltipModifications,
    hideAllGuidanceTooltipModifications,
    modifications,
  } = useEditor();

  const reset = () => {
    setAreTooltipsVisible(false);
  };

  const handleOnSelect = () => {
    setAreTooltipsVisible(!areTooltipsVisible);
    onButtonClick(!areTooltipsVisible);

    areTooltipsVisible
      ? hideAllGuidanceTooltipModifications()
      : showAllGuidanceTooltipModifications();
  };

  const isButtonDisabled = useMemo(
    () =>
      modifications.filter(
        (modification) => modification.modificationType === 'tooltip'
      ).length === 0,
    [modifications]
  );

  return (
    <div className="flex align-center">
      <TooltipBubble
        title={
          areTooltipsVisible
            ? 'Hide guidance tooltips'
            : 'Show guidance tooltips'
        }
        placement="left"
      >
        <ToggleButton
          dark
          selected={areTooltipsVisible}
          icon={<BalloonOutlineIcon size={20} />}
          onSelect={handleOnSelect}
          disabled={isButtonDisabled}
          ariaLabel="guidance-tooltip-button"
        />
      </TooltipBubble>
    </div>
  );
});

GuidanceTooltipsButton.displayName = 'GuidanceTooltipsButton';
